export default "__VITE_ASSET__854d78c8__"